import { Flag } from 'lucide-react'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { SUPPORTED_LOCALES, SupportedLanguages } from '../../../i18n/config'
import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Button } from '../../shared/button/button'

export const HeaderLanguageSwitch = forwardRef(function HeaderLanguageSwitch(
  { ...props },
  ref,
) {
  const { i18n } = useTranslation()

  const currentLanguage = i18n.resolvedLanguage as SupportedLanguages
  const nextLanguage =
    SUPPORTED_LOCALES.filter((locale) => locale !== currentLanguage)[0] ??
    currentLanguage

  return (
    <Button
      size="sm"
      variant="outline"
      iconStart={<Flag className="hidden md:inline h-4 w-4" />}
      onClick={() => i18n.changeLanguage(nextLanguage)}
      {...props}
      ref={ref}
    >
      {nextLanguage.toUpperCase()}
    </Button>
  )
}) as Polymorphic<'button'>
